import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import Overview from "@/pages/Overview";
import Contacts from "@/pages/Contacts";
import Pipeline from "@/pages/Pipeline";
import Tasks from "@/pages/Tasks";
import CalendarPage from "@/pages/CalendarPage";
import Campaigns from "@/pages/Campaigns";
import SMS from "@/pages/SMS";
import Dialer from "@/pages/Dialer";
import Profile from "@/pages/Profile";
import Activity from "@/pages/Activity";
import AdminTraining from "@/pages/AdminTraining";
import AcceptInvite from "@/pages/AcceptInvite";

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-[#3B185F]" data-testid="auth-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/accept-invite" element={<AcceptInvite />} />
      <Route path="/" element={<Protected><Layout /></Protected>}>
        <Route index element={<Overview />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="pipeline" element={<Pipeline />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="campaigns" element={<Campaigns />} />
        <Route path="sms" element={<SMS />} />
        <Route path="dialer" element={<Dialer />} />
        <Route path="profile" element={<Profile />} />
        <Route path="activity" element={<Activity />} />
        <Route path="admin/training" element={<Protected admin><AdminTraining /></Protected>} />
        <Route path="admin/students" element={<Navigate to="/admin/training?tab=users" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}
